module.exports = __webpack_public_path__ + "static/media/experimentation@2x.d18ea48c.png";